// extracted by mini-css-extract-plugin
export default {"loading-pulse":"components-payment-billing-details-module__loading-pulse","pulse":"components-payment-billing-details-module__pulse"};